import { useState } from "react";
import { api } from "../../services/api";
import { ContainerBackground, ContainerModal } from "../Modal/styles";
import { StatusContainer } from "./styles";

export const Modal2 = ({ showEditModal, setShowEditModal }) => {
  const token = localStorage.getItem("@Kenzie_Hub_USER_TOKEN");
  const [status, setStatus] = useState();
  const [edit, setEdit] = useState();

  const handleSubmit = (event) => {
    event.preventDefault();
  };
  const editCard = (id) => {
    console.log("id ", id);
    console.log("edit ", edit);
    setEdit({ status: status });
    api
      .put(`/users/techs/${id}`, edit, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        console.log(res);
      })
      .catch((err) => console.log(err));
  };
  return showEditModal ? (
    <ContainerBackground>
      <ContainerModal onSubmit={(event) => handleSubmit(event)}>
        <header>
          <h1>Tecnologia Status</h1>
          <p onClick={() => setShowEditModal((value) => !value)}>x</p>
        </header>
        <StatusContainer>
          <h1>Status</h1>
          <select onChange={(event) => setStatus(event.target.value)}>
            <option>Iniciante</option>
            <option>Intermediário</option>
            <option>Avançado</option>
          </select>
          <button type="submit" onClick={() => editCard()}>
            Salvar Alterações
          </button>
        </StatusContainer>
      </ContainerModal>
    </ContainerBackground>
  ) : null;
};
